import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useSyncStateToQueryParam(
  state: Record<string, unknown | undefined>,
) {
  const { search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const prevParams = new URLSearchParams(search);
    const nextParams = new URLSearchParams(search);
    // If the value is undefined, remove the key from the URL
    Object.entries(state).forEach(([key, value]) => {
      if (value === undefined) {
        nextParams.delete(key);
      } else {
        nextParams.set(key, JSON.stringify(value));
      }
    });

    if (prevParams.toString() !== nextParams.toString()) {
      navigate({ search: nextParams.toString() }, { replace: true });
    }
  }, [state, navigate, search]);
}
